/**
 * 在途监管平台 — 认证模块
 * 企业端/政府端：POST /api/v1/auth/login（请求 {username, password}，username 可填账号或手机号）
 * 司机端（N6）：POST /api/v1/driver/auth/login（请求 {phone, password}，司机档案独立登录，返回标准 JWT）
 * ★ 2026-08-24 清理：移除 mock 登录降级 — 生产环境网络错误时返回假 token
 *   会让用户带着 mock-token 进入系统（后续请求全部 401，且假 token 无任何安全校验），
 *   属于 T4「后门入口」类残留。网络错误一律原样抛出，由页面提示。
 */
import { post } from './http';
import type { DriverLoginResult, LoginResult } from '@/types';

export interface LoginParams {
  username: string;
  password: string;
}

export interface DriverLoginParams {
  phone: string;
  password: string;
}

/** 登录（账号或手机号 + 密码） */
export async function login(params: LoginParams): Promise<LoginResult> {
  return post<LoginResult>('/auth/login', params);
}

/** 司机独立登录（司机手机号 + 独立密码；N6 接入 /driver/auth/login） */
export async function driverLogin(params: DriverLoginParams): Promise<DriverLoginResult> {
  return post<DriverLoginResult>('/driver/auth/login', params);
}
